import { styled, Alert, Snackbar, Theme } from '@mui/material';

import { SnackbarPosition } from './Snackbar';

interface AdditionalSnackbarStyledProps {
  position?: SnackbarPosition;
  $zIndex?: number;
}

export const SnackbarStyled = styled(Snackbar)<AdditionalSnackbarStyledProps>(
  ({ theme, position, $zIndex }) => ({
    bottom: getBottomPosition(theme, position),
    boxShadow: theme.customShadow,
    zIndex: $zIndex ?? theme.zIndex.snackbar,
    position: 'fixed',
    left: '50%',
    transform: 'translateX(-50%)',
    '@media (min-width: 744px)': {
      top: '84px',
      bottom: 'auto',
      width: '438px',
    },
    '@media (min-width:994px)': {
      width: '594px',
    },
  })
);

const getBottomPosition = (theme: Theme, position?: SnackbarPosition) => {
  switch (position) {
    case 'bottom':
      return '1.6rem';
    case 'aboveNativeAuthDialog':
      return `${
        theme.customSizes.nativeAuthDialogHeight + theme.spacingUnitless(2)
      }rem`;
    default:
      return `${
        theme.customSizes.bottomNavigationHeight + theme.spacingUnitless(2)
      }rem`;
  }
};

export const AlertStyled = styled(Alert)(({ theme }) => ({
  padding: 0,
  alignItems: 'center',
  width: '100%',
  backgroundColor: theme.palette.common.white,
  color: theme.palette.primaryDark.main,

  '.MuiAlert-message': {
    ...theme.typography.caption,
  },

  '.MuiAlert-icon': {
    alignItems: 'center',
    alignSelf: 'stretch',
    padding: theme.spacing(3, 2),
    fontSize: '2.4rem',
    color: theme.palette.common.white,
  },

  '.MuiAlert-action': {
    marginRight: theme.spacing(4),
    padding: 0,
    '.MuiSvgIcon-root': {
      height: '2.4rem',
      width: '2.4rem',
    },
  },

  '&.MuiAlert-filledSuccess': {
    border: `0.1rem solid ${theme.palette.success.main}`,
    '.MuiAlert-icon': {
      backgroundColor: theme.palette.success.main,
    },
  },

  '&.MuiAlert-filledInfo': {
    border: `0.1rem solid ${theme.palette.info.main}`,
    '.MuiAlert-icon': {
      backgroundColor: theme.palette.info.main,
    },
  },

  '&.MuiAlert-filledWarning': {
    border: `0.1rem solid ${theme.palette.warning.main}`,
    '.MuiAlert-icon': {
      backgroundColor: theme.palette.warning.main,
    },
  },

  '&.MuiAlert-filledError': {
    border: `0.1rem solid ${theme.palette.error.main}`,
    '.MuiAlert-icon': {
      backgroundColor: theme.palette.error.main,
    },
  },
})) as typeof Alert;
